import { useUsuarioActual } from '@/hooks/useSolicitudesContado';
import { CircleNotch } from '@phosphor-icons/react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { HeaderAdelante } from './HeaderAdelante';

const RUTA_SOLICITUDES = '/vencimientos/solicitudes';

/**
 * Layout principal de la app: header oscuro + área de contenido light.
 *
 * Se usa como elemento `element` de la ruta padre. Las pantallas hijas
 * se renderizan dentro de `<Outlet />`. Quien tiene el perfil Proveeduría solo puede estar en
 * Solicitudes de contado: cualquier otra ruta lo devuelve ahí (la API además se lo niega).
 */
export function LayoutPrincipal() {
  const { pathname } = useLocation();
  const { data, isLoading } = useUsuarioActual();
  const soloSolicitudes = !!data?.data?.soloSolicitudes;
  const permitida = pathname === RUTA_SOLICITUDES || pathname.startsWith(`${RUTA_SOLICITUDES}/`);

  return (
    <div className="min-h-screen bg-zinc-50 text-foreground">
      <HeaderAdelante />
      <main className="container mx-auto max-w-7xl px-6 py-8">
        {isLoading ? (
          <div className="flex items-center gap-2 text-muted-foreground">
            <CircleNotch className="h-4 w-4 animate-spin" weight="bold" aria-hidden="true" />
            Cargando…
          </div>
        ) : soloSolicitudes && !permitida ? (
          <Navigate to={RUTA_SOLICITUDES} replace />
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
}
